module.exports = __webpack_public_path__ + "img/admin2.a3ba9a79.png";